<script>
import DateRangePicker from 'vue2-daterange-picker';

/**
 * @description Компонент выбора отрезка дат.
 * @type {Vue}
 */
export default {
  extends: DateRangePicker,
  methods: {
    /**
     * @description Обработать наведение на дату.
     * @param {Date} value
     * @returns {void}
     */
    hoverDate(value) {
      if (this.readonly) {
        return;
      }
      const dtEnd = this.normalizeDatetime(value, this.end);
      const dtStart = this.normalizeDatetime(value, this.start);
      if (this.in_selection) {
        if (dtEnd > this.in_selection) {
          this.start = this.in_selection;
          this.end = dtEnd;
        } else {
          this.end = this.in_selection;
          this.start = dtStart;
        }
      }
      this.$emit('hover-date', value);
    },
  },
  name: 'DateRangePicker',
};
</script>
